// Pasos del mes, segunda mitad: Textos, Diseños, Videos y Publicar (y las etiquetas fijas que les llegan de la API
// y de packages/core: modelos de video, formatos de reel, regiones de voz, estados de publicación).
export default {
  // Comunes a estas pantallas
  'Empezando…': 'Starting…',
  'Pieza {n}': 'Post {n}',
  texto: 'text',
  hashtags: 'hashtags',
  todo: 'everything',
  'texto de LinkedIn': 'LinkedIn text',
  Reel: 'Reel',
  Reels: 'Reels',
  Carrusel: 'Carousel',
  Carruseles: 'Carousels',
  'Estática': 'Single image',
  Imagen: 'Image',
  'Imágenes': 'Images',
  Todas: 'All',
  Descargar: 'Download',
  Comentar: 'Comment',
  Compartir: 'Share',

  // Textos
  Textos: 'Posts',
  'Lo que dice cada publicación del mes, lista para copiar y pegar.': "What each of this month's posts says, ready to copy and paste.",
  'Primero aprueba el plan del mes; con él escribimos los textos.': "First approve this month's plan; we write the posts from it.",
  'Escribo el texto de cada publicación del plan de {mes}: lo que se dice, el pie y los hashtags.':
    "I'll write the text for every post in the {mes} plan: what's said, the caption and the hashtags.",
  'Escribir mis textos': 'Write my posts',
  'Tarda uno o dos minutos.': 'It takes a minute or two.',
  'Publicación {n}': 'Post {n}',
  Publicaciones: 'Posts',
  'Escritas y revisadas': 'Written and reviewed',
  'Guiones de reel': 'Reel scripts',
  'Le faltan datos que solo tú sabes': 'Missing details only you know',
  'No hay publicaciones con ese filtro.': 'No posts match that filter.',
  'Faltan datos': 'Missing details',
  Guion: 'Script',
  'Láminas': 'Slides',
  'Diseño': 'Design',
  'Publicación': 'Post',
  'Pedir un cambio': 'Ask for a change',
  'Tú en cámara': 'You on camera',
  'Con presentadora de IA': 'With an AI presenter',
  'Voz en off': 'Voice-over',
  'Solo texto': 'Text only',
  Gancho: 'Hook',
  Cuerpo: 'Body',
  Cierre: 'Closing',
  Portada: 'Cover',
  Contenido: 'Content',
  Llamado: 'Call to action',
  '{total} s en total': '{total} s total',
  'Se ve': 'On screen',
  'Se dice': 'Spoken',
  'En pantalla': 'Text on screen',
  'Edición': 'Editing',
  '{n} láminas': '{n} slides',
  'Imagen:': 'Image:',
  'Idea visual:': 'Visual idea:',
  'Completa estos datos antes de publicar: solo tú los sabes': 'Fill in these details before posting: only you know them',
  'Instagram y Facebook': 'Instagram and Facebook',
  'Texto alternativo (para quien no ve la imagen)': "Alt text (for people who can't see the image)",
  '¿Quieres cambiar algo de esta publicación?': 'Want to change something in this post?',
  'Ej.: que el gancho sea una pregunta, que mencione el precio, más corto…':
    'E.g.: make the hook a question, mention the price, make it shorter…',
  'Solo se reescribe esta publicación; las demás no cambian.': "Only this post gets rewritten; the others don't change.",
  'Reescribir · {costo} crédito': 'Rewrite · {costo} credit',
  'Reescribir · {costo} créditos': 'Rewrite · {costo} credits',
  'Por qué funciona': 'Why it works',

  // Diseños
  'Diseños': 'Designs',
  'Tus estáticas y carruseles del mes, con tu estilo y listos para publicar.':
    "This month's single images and carousels, in your style and ready to post.",
  'Primero aprueba los textos: los diseños se arman con ellos.': 'First approve the posts: the designs are built from them.',
  'Este mes no hay estáticas ni carruseles que diseñar.': 'There are no single images or carousels to design this month.',
  'Estas son las publicaciones que se diseñan. Los reels se hacen en el paso de videos.':
    'These are the posts that get designed. Reels are made in the videos step.',
  'Diseñar mis publicaciones': 'Design my posts',
  'Tarda alrededor de un minuto. Cada estática usa {estatica} créditos y cada carrusel, {carrusel}.':
    'It takes about a minute. Each single image uses {estatica} credits and each carousel, {carrusel}.',
  'Portada de reel': 'Reel cover',
  'Descargar todo': 'Download everything',
  Todo: 'All',
  'Pieza anterior': 'Previous post',
  'Pieza siguiente': 'Next post',
  'de {total} · usa las flechas de tu teclado': 'of {total} · use your keyboard arrows',
  'Portada del reel': 'Reel cover',
  'Lámina {n}': 'Slide {n}',
  'Lámina anterior': 'Previous slide',
  'Lámina siguiente': 'Next slide',
  'Carrusel de {n}': 'Carousel of {n}',
  'Esta es la portada de tu reel': 'This is your reel cover',
  'Es la imagen fija que se ve en tu perfil. El video se hace en el paso de videos.':
    'It’s the still image people see on your profile. The video is made in the videos step.',
  'Hacer el video de este reel': 'Make the video for this reel',
  'Así se verá la portada en tus {n} redes': 'How the cover will look on your {n} networks',
  'Así se verá publicada en tus {n} redes': 'How it will look on your {n} networks',
  'Así se verá la portada en {red}': 'How the cover will look on {red}',
  'Así se verá publicada en {red}': 'How it will look on {red}',
  'Ahora · Público': 'Just now · Public',
  'Me gusta': 'Like',
  'Seguidores · Ahora': 'Followers · Just now',
  '…ver más': '…see more',
  Recomendar: 'Like',
  Enviar: 'Send',
  'Tu pieza en TikTok': 'Your post on TikTok',

  // Videos
  Videos: 'Videos',
  'Tus reels, escena por escena. Tú eliges con qué calidad se hacen y cuántos créditos usan.':
    'Your reels, scene by scene. You choose the quality and how many credits they use.',
  'Primero elige quién sale en tus reels.': 'First choose who appears in your reels.',
  'Primero aprueba los textos: de ahí sale lo que se dice en cada escena.':
    "First approve the posts: that's where what's said in each scene comes from.",
  'Este mes no hay reels en tu plan.': 'There are no reels in your plan this month.',
  'Sale {nombre} en todos.': '{nombre} appears in all of them.',
  'Su cara todavía no está fijada. Puedes hacer los videos igual, pero el rostro cambiará un poco de uno a otro. Fijarla cuesta 1 crédito y se hace en el paso de tu presentadora.':
    "Their face isn't locked in yet. You can still make the videos, but the face will change a little from one to the next. Locking it costs 1 credit and is done in your presenter step.",
  'Video listo, con la voz de {nombre}': "Video ready, with {nombre}'s voice",
  'Video listo, con voz en off': 'Video ready, with voice-over',
  'Video listo': 'Video ready',
  'Sin hacer': 'Not made yet',
  'Revisa estas escenas antes de publicar': 'Check these scenes before posting',
  'La escena {escena} {motivo}.': 'Scene {escena} {motivo}.',
  'Calculando…': 'Calculating…',
  '{formato} · {escenas} escenas · {segundos} segundos en total': '{formato} · {escenas} scenes · {segundos} seconds total',
  'Quién sale en este video': 'Who appears in this video',
  'sin fijar': 'not locked in',
  'Escena {codigo}': 'Scene {codigo}',
  'Voz en off: «{narra}»': 'Voice-over: “{narra}”',
  'Sin voz': 'No voice',
  'Este video necesita ver cómo queda cada escena antes de grabarla. Dibujamos la imagen, la revisas y, si te gusta, hacemos el video.':
    "This video needs to see how each scene looks before filming it. We'll draw the image, you review it and, if you like it, we make the video.",
  'Este video necesita ver cómo queda cada escena antes de grabarla. Dibujamos las {n} imágenes, las revisas y, si te gustan, hacemos el video.':
    "This video needs to see how each scene looks before filming it. We'll draw the {n} images, you review them and, if you like them, we make the video.",
  'Dibujar las escenas': 'Draw the scenes',
  '{creditos} créditos · mucho menos que el video, y evita pagarlo dos veces.':
    '{creditos} credits · much less than the video, and it saves you paying for it twice.',
  Recomendada: 'Recommended',
  '{n} créditos': '{n} credits',
  'A cambio:': 'The trade-off:',
  'Rehacer este video': 'Redo this video',
  'Hacer este video': 'Make this video',
  'Se descuentan al terminar. Si algo falla, no se cobra.': "They're deducted when it's done. If something fails, you aren't charged.",
  'La voz': 'The voice',
  'Voz automática': 'Automatic voice',
  Incluida: 'Included',
  'Suena con el acento de tu país y la edad de quien sale. Para la mayoría de videos basta.':
    "It sounds like your country's accent and the age of whoever appears. It's enough for most videos.",
  'Elegir la voz': 'Choose the voice',
  '+{n} créditos': '+{n} credits',
  'Escoges exactamente cómo suena: la región, el tono. La boca sigue cuadrando con lo que dice.':
    'You choose exactly how it sounds: the region, the tone. The lips still match what’s said.',
  'Escuchar a {nombre}': 'Listen to {nombre}',
  Elegida: 'Selected',

  // Videos: modelos (packages/core/src/video/modelos.ts)
  'La mejor': 'The best',
  'La cara y el sitio se mantienen iguales en todos tus videos y, cuando alguien habla, la boca va exacta con lo que dice. Cada escena dura justo lo que dura la frase.':
    'The face and the setting stay the same across all your videos, and when someone speaks, their lips match exactly. Each scene lasts just as long as the line.',
  'Es la que más créditos usa.': 'It uses the most credits.',
  Equilibrada: 'Balanced',
  'Muy buena calidad por bastantes menos créditos. La boca va bien con lo que dice.':
    'Very good quality for quite a few fewer credits. The lips match what’s said well.',
  'Sujeta la cara con menos referencias, así que en videos largos puede cambiar un poco. Las escenas duran 4, 6 u 8 segundos, no lo justo.':
    'It holds the face with fewer references, so it may change a little in long videos. Scenes last 4, 6 or 8 seconds, not the exact length.',
  'Básica': 'Basic',
  'La opción de prueba: sale un video y cuesta poco.': 'The trial option: you get a video and it costs little.',
  'No usa fotos de referencia, así que la cara cambia de un video a otro. No la recomendamos si sale una persona hablando.':
    "It doesn't use reference photos, so the face changes from one video to another. We don't recommend it if someone is speaking.",
  'Para escenas sin voz': 'For scenes without a voice',
  'La más barata con diferencia. Va perfecta para planos de producto, de lugares o de apoyo.':
    'By far the cheapest. Perfect for product shots, places or supporting footage.',
  'Su voz no es buena, así que no sirve para alguien hablando a cámara.': "Its audio isn't good, so it doesn't work for someone talking to the camera.",

  // Videos: formatos (packages/prompts/formatos/*.json)
  'App / software': 'App / software',
  'Dualcast · 2 en un plano': 'Dualcast · 2 in one shot',
  'Moda / haul': 'Fashion / haul',
  'Podcast · 2 personas': 'Podcast · 2 people',
  'Trend antes / después': 'Before / after trend',
  'UGC con producto': 'UGC with product',
  'UGC sin producto': 'UGC without product',
  'Voz en off · lifestyle': 'Voice-over · lifestyle',

  // Videos: regiones de voz (packages/core/src/video/voces.ts)
  'Bogotá': 'Bogotá',
  'Medellín (paisa)': 'Medellín (paisa)',
  'Colombiana neutra': 'Neutral Colombian',
  Cali: 'Cali',
  'Mexicana neutra': 'Neutral Mexican',
  'Ciudad de México': 'Mexico City',
  'Monterrey (norteño)': 'Monterrey (northern)',
  Argentina: 'Argentine',
  'Buenos Aires': 'Buenos Aires',
  Uruguay: 'Uruguayan',
  Castellana: 'Castilian',
  'Andalucía': 'Andalusian',
  Madrid: 'Madrid',
  'Latinoamericana neutra': 'Neutral Latin American',

  // Videos: avisos guardados por el motor (apps/api/src/jobs/run.ts y packages/core/src/video/revision.ts)
  'se quedó con la voz a medias porque el video se acababa': 'has its voice cut off because the video was ending',
  'tiene la voz elegida, pero puede que se oiga incompleta': 'has the chosen voice, but it may sound incomplete',
  'se quedó con la voz automática porque la voz elegida falló': 'kept the automatic voice because the chosen voice failed',
  'dijo otra cosa': 'said something else',
  'se saltó parte de lo que tenía que decir': 'skipped part of what it had to say',
  'añadió frases que no estaban en el guion': "added lines that weren't in the script",
  'salió bien': 'came out fine',
  'Este video se quedó sin voz en off: al motor le falta la clave de Google.': 'This video has no voice-over: the engine is missing the Google key.',
  'Este video se quedó sin voz en off: no salió el audio.': "This video has no voice-over: the audio didn't come out.",

  // Publicar
  Publicar: 'Publish',
  'Le falta contenido': 'Missing content',
  'Lista para programar': 'Ready to schedule',
  Programada: 'Scheduled',
  Publicada: 'Published',
  'Falló': 'Failed',
  Lun: 'Mon',
  Mar: 'Tue',
  'Mié': 'Wed',
  Jue: 'Thu',
  Vie: 'Fri',
  'Sáb': 'Sat',
  Dom: 'Sun',
  'Listo: quedó programada 1 publicación.': 'Done: 1 post scheduled.',
  'Listo: quedaron programadas {n} publicaciones.': 'Done: {n} posts scheduled.',
  'No había nada nuevo para programar.': 'There was nothing new to schedule.',
  'Ya estaba programada.': 'It was already scheduled.',
  'Si tu video ya decía ese dato, rehazlo en Video.': 'If your video already said that detail, redo it in Video.',
  'Diseñando esta publicación…': 'Designing this post…',
  'No se pudo diseñar.': "We couldn't design it.",
  'Ir a Textos': 'Go to Texts',
  "Este video ya salió en tus redes.": "This video is already live on your networks.",
  "Este video ya tiene día y hora: sale solo.": "This video already has a day and time: it goes out on its own.",
  "Ver en Programación": "View in Scheduling",
  "Este video son tus frases en movimiento: se anima gratis y queda en tu publicación.": "This video is your phrases in motion: animated for free and saved to your post.",
  "Antes de grabar, IGOR dibuja cómo se ve cada escena. Las revisas y, si te gustan, se hace el video. Así no pagas un video que no te gusta.": "Before recording, IGOR draws what each scene looks like. You review them and, if you like them, the video gets made. That way you never pay for a video you don't like.",
  "Así va a quedar el video, escena por escena. Si te parece bien, sigue al video.": "This is how the video will look, scene by scene. If it looks good, move on to the video.",
  "Cambiar el guion": "Change the script",
  "Cambiar la voz (opcional)": "Change the voice (optional)",
  "Empezar en el Estudio": "Start in the Studio",
  "Es lo que se va a decir en el video. Lo escribió IGOR con tu plan del mes.": "It's what will be said in the video. IGOR wrote it from your monthly plan.",
  "Esta publicación todavía no tiene guion.": "This post doesn't have a script yet.",
  "Esta publicación todavía no tiene texto.": "This post doesn't have copy yet.",
  "Este video es una pequeña historia con escenas. Se hace en el Estudio: IGOR escribe la historia, dibuja las escenas y las anima; tú revisas cada paso.": "This video is a short story with scenes. It is made in the Studio: IGOR writes the story, draws the scenes and animates them; you review each step.",
  "Este video todavía no está hecho.": "This video isn't made yet.",
  "Guardar en mi publicación": "Save to my post",
  "Hacer el video · {n} créditos": "Make the video · {n} credits",
  "IGOR graba el video con tu presentadora. Te recomendamos esta calidad; puedes cambiarla abajo.": "IGOR records the video with your presenter. We recommend this quality; you can change it below.",
  "Las escenas": "The scenes",
  "Mira tu video con subtítulos y tu logo. Ajusta lo que quieras y guárdalo: así se publica.": "Watch your video with captions and your logo. Adjust anything you like and save it: that's how it gets posted.",
  "Pasos de este video": "This video's steps",
  "Quién sale": "Who appears",
  "Rehacer el video": "Redo the video",
  "Se ve bien, siguiente": "Looks good, next",
  "Seguir con otro video": "Continue with another video",
  "Tu video quedó guardado en su publicación. Lo que sigue es programarlo.": "Your video is saved to its post. Next, schedule it.",
  "Tus frases en movimiento, con tus colores y tus letras. Elige el fondo, míralo y guárdalo en tu publicación. No usa créditos.": "Your phrases in motion, with your colors and fonts. Pick the background, watch it and save it to your post. Doesn't use credits.",
  "Ver otras calidades": "See other qualities",
  "Volver a editarlo": "Edit it again",
  "Volver a las escenas": "Back to the scenes",
  "¿Está bien el guion?": "Is the script right?",
  "Por empezar": "Not started",
  "Crear otro video": "Create another video",
  "El siguiente paso es programarlos.": "The next step is to schedule them.",
  "Hecho": "Done",
  "Ir a Programación": "Go to Scheduling",
  "Listo para programar": "Ready to schedule",
  "Más opciones": "More options",
  "Opcional": "Optional",
  "Para videos fuera de tu plan del mes, tus presentadores y personajes, y tus fotos y videos propios. No hace falta para tus videos del mes.": "For videos outside your monthly plan, your presenters and characters, and your own photos and videos. Not needed for your monthly videos.",
  "Paso {n} de 4": "Step {n} of 4",
  "Paso {n} de 4 · {paso}": "Step {n} of 4 · {paso}",
  "Programado": "Scheduled",
  "Publicado": "Published",
  "Si quieres uno, créalo en «Más opciones», abajo.": "If you want one, create it under “More options” below.",
  "Te toca revisar · {paso}": "Your turn to review · {paso}",
  "Todos tus videos del mes": "All your videos this month",
  "Tu plan de este mes no tiene videos": "This month's plan has no videos",
  "Tus videos del mes": "Your videos this month",
  "Tus {n} videos del mes están listos": "Your {n} videos this month are ready",
  "Un comercial, un corto, un tráiler… fuera de tu plan": "An ad, a short, a trailer… outside your plan",
  "Cada video pasa por 4 pasos: guion, escenas, video y revisar. IGOR te dice cuál sigue.": "Each video goes through 4 steps: script, scenes, video and review. IGOR tells you which one is next.",
  "Siguiente: tus videos del mes": "Next: your videos this month",
  "Grabación": "Recording",
  "Historia y escenas": "Story and scenes",
  "Revisar y guardar": "Review and save",
  "Escribir el guion": "Write the script",
  "Hacer el video": "Make the video",
  "Empezar": "Start",
  "Revisar la historia": "Review the story",
  "Revisar las escenas": "Review the scenes",
  "Revisar el video": "Review the video",
  "Montar voz y música": "Add voice and music",
  "Guardar en tu mes": "Save to your month",
  "Tu presentadora dice el guion a cámara. IGOR lo hace todo.": "Your presenter says the script to camera. IGOR does everything.",
  "Lo grabas tú con el celular; IGOR lo corta y le pone subtítulos.": "You record it with your phone; IGOR trims it and adds captions.",
  "Tus frases en movimiento con tus colores. Gratis.": "Your phrases in motion, in your colors. Free.",
  "Una pequeña historia con escenas, como un comercial.": "A short story with scenes, like an ad.",
  "Este video lo grabas tú con el guion de tus textos: lo subes y IGOR lo edita.": "You record this video with the script from your copy: upload it and IGOR edits it.",
  "Subir tu grabación": "Upload your recording",
  "Esa publicación no está en el plan de este mes.": "That post isn't in this month's plan.",
  "Tu video pesa más de 50 MB: expórtalo en 1080p o recórtalo y vuelve a subirlo.": "Your video is over 50 MB: export it in 1080p or trim it and upload it again.",
  "Subiendo tu video…": "Uploading your video…",
  "No pudimos leer tu video. Intenta de nuevo.": "We couldn't read your video. Try again.",
  "Escuchando tu video palabra por palabra…": "Listening to your video word by word…",
  "No entendimos la voz del video: se edita sin cortes de tomas ni subtítulos.": "We couldn't understand the voice in the video: it's edited without take cuts or captions.",
  "Listo: tu video quedó en la publicación del {dia}. Prográmala en Publicar.": "Done: your video is now on the {dia} post. Schedule it in Publishing.",
  "Tu grabación": "Your recording",
  "Tu guion": "Your script",
  "Esta publicación todavía no tiene guion: escríbelo en Textos.": "This post doesn't have a script yet: write it in Texts.",
  "Para que el corte salga solo": "So the edit works on its own",
  "Graba en vertical, con buena luz de frente y el celular a la altura de los ojos.": "Record vertically, with good light in front of you and the phone at eye level.",
  "¿Te equivocaste? Haz una pausa y repite la frase completa desde el principio: IGOR se queda con la última.": "Made a mistake? Pause and say the whole sentence again from the start: IGOR keeps the last one.",
  "Deja un segundo de silencio al empezar y al terminar.": "Leave a second of silence at the start and at the end.",
  "Sin filtros, textos ni música: eso lo pone IGOR.": "No filters, text or music: IGOR adds those.",
  "Esta publicación ya tiene tu video": "This post already has your video",
  "Esta publicación ya tiene un video": "This post already has a video",
  "Si subes otro, reemplaza a este.": "If you upload another one, it replaces this one.",
  "Subir mi grabación": "Upload my recording",
  "MP4 o MOV, hasta 50 MB. IGOR la escucha palabra por palabra para cortar y poner subtítulos (1 crédito; si no se entiende la voz, no se cobra).": "MP4 or MOV, up to 50 MB. IGOR listens to it word by word to cut it and add captions (1 credit; if the voice can't be understood, it's free).",
  "Usar en esta publicación": "Use on this post",
  "Te damos el guion; lo grabas con tu celular y IGOR lo edita.": "We give you the script; you record it with your phone and IGOR edits it.",
  'Sin repeticiones ni pausas': 'No retakes or pauses',
  '{n} toma(s) repetida(s)': '{n} repeated take(s)',
  '{n} palabra(s) repetida(s)': '{n} repeated word(s)',
  '{n} pausa(s) larga(s)': '{n} long pause(s)',
  '{s} s menos': '{s} s shorter',
  'IGOR escucha tu video palabra por palabra: pone los subtítulos justo cuando hablas y quita solo las tomas repetidas, las palabras que se te trabaron y las pausas largas (1 crédito; si no se entiende la voz, no se cobra). Después editas gratis: logo, ritmo, color y transiciones.': "IGOR listens to your video word by word: it times the captions to when you speak and removes only repeated takes, words you stumbled on and long pauses (1 credit; if the voice can't be understood, it's free). Then you edit for free: logo, pace, color and transitions.",
  'Hora de {zona}': '{zona} time',
  'En tu hora ({zona}) sale a las {hora}.': 'In your time ({zona}) it goes out at {hora}.',
  'Cambiar zona': 'Change time zone',
  '¿En qué hora se programa esta marca? Aplica a todas sus publicaciones.': "Which time zone does this brand schedule in? It applies to all its posts.",
  'México (centro)': 'Mexico (central)',
  'México (Quintana Roo)': 'Mexico (Quintana Roo)',
  'México (Chihuahua)': 'Mexico (Chihuahua)',
  'México (Pacífico)': 'Mexico (Pacific)',
  'México (Baja California)': 'Mexico (Baja California)',
  'Perú': 'Peru',
  'Panamá': 'Panama',
  'República Dominicana': 'Dominican Republic',
  'Brasil (São Paulo)': 'Brazil (São Paulo)',
  'EE. UU. (Este)': 'US (Eastern)',
  'EE. UU. (Centro)': 'US (Central)',
  'EE. UU. (Montaña)': 'US (Mountain)',
  'EE. UU. (Pacífico)': 'US (Pacific)',
  'España': 'Spain',
  'Eliminar programación': 'Delete schedule',
  '¿Eliminamos esta programación? Se quita de todas sus redes y no se publicará. La pieza sigue en IGOR y puedes volver a programarla.': "Delete this schedule? It's removed from all its networks and won't be posted. The post stays in IGOR and you can schedule it again.",
  'Eliminando…': 'Deleting…',
  'Sí, eliminarla': 'Yes, delete it',
  'No, dejarla': 'No, keep it',
  '¿Borramos esta pieza? Después puedes volver a diseñarla. No se devuelven los créditos que ya se usaron.': 'Delete this piece? You can design it again later. Credits already used are not refunded.',
  'Sí, borrarla': 'Yes, delete it',
  'Sin diseño ({n})': 'No design ({n})',
  'Diseñar ({n} créditos)': 'Design ({n} credits)',
  'Todavía no tiene texto.': "It doesn't have copy yet.",
  'Completa estos datos: solo tú los sabes': 'Fill in these details: only you know them',
  'Guardar datos': 'Save details',
  'No usa créditos.': "Doesn't use credits.",
  'Le falta el video.': "It's missing its video.",
  'Ir a Video': 'Go to Video',
  'Su diseño todavía muestra el dato sin completar.': 'Its design still shows the missing detail.',
  'Le falta el diseño.': "It's missing its design.",
  'Diseñando…': 'Designing…',
  'Rehacer el diseño ({n} créditos)': 'Redo the design ({n} credits)',
  'Diseñar ahora ({n} créditos)': 'Design now ({n} credits)',
  '¿Cancelamos esta publicación? Se quita de todas sus redes.': 'Cancel this post? It will be removed from all its networks.',
  'Programamos tus publicaciones en tus redes.': 'We schedule your posts on your social networks.',
  'La programación se activa desde nuestro equipo. Escríbenos.': 'Scheduling is turned on by our team. Write to us.',
  'Tu mes en el calendario: arrastra una pieza para cambiarla de día y prográmala en sus redes.':
    'Your month on the calendar: drag a post to change its day and schedule it on its networks.',
  'Estas no se programaron': "These weren't scheduled",
  'Este mes todavía no tiene plan. Ármalo en "Plan del mes" y vuelve aquí para programarlo.':
    'This month doesn’t have a plan yet. Build it in "Monthly plan" and come back here to schedule it.',
  'Listas para programar': 'Ready to schedule',
  Programadas: 'Scheduled',
  Publicadas: 'Published',
  'Por resolver': 'To sort out',
  'Falta contenido o falló': 'Missing content or failed',
  'Programando…': 'Scheduling…',
  'Programar todo lo listo ({n})': 'Schedule everything ready ({n})',
  'Arrastra una pieza a otro día para moverla. Si ya estaba programada, la reprogramamos sola.':
    "Drag a post to another day to move it. If it was already scheduled, we'll reschedule it for you.",
  'Toca una pieza del calendario para ver su detalle y programarla.': 'Tap a post on the calendar to see its details and schedule it.',
  'Publicamos siempre en tu cuenta, nunca en la nuestra. Programar no usa créditos. Antes de publicar, activa en tu red la marca de contenido hecho con IA.':
    'We always post on your account, never ours. Scheduling doesn’t use credits. Before posting, turn on the AI-generated content label on your network.',
  'Esta publicación': 'This post',
  'Día': 'Day',
  Hora: 'Time',
  'Dónde sale': 'Where it goes',
  'No tienes esta red conectada': "You don't have this network connected",
  'sin conectar': 'not connected',
  'Guardando…': 'Saving…',
  'Guardar y reprogramar': 'Save and reschedule',
  'Guardar cambios': 'Save changes',
  Programar: 'Schedule',
  'Intentar de nuevo': 'Try again',
  Cancelar: 'Cancel',
  'Le falta el video o el texto: hazlo en su paso y vuelve.': "It's missing the video or the text: make it in its step and come back.",
  'Le falta el diseño o el texto: hazlo en su paso y vuelve.': "It's missing the design or the text: make it in its step and come back.",
  'Guarda los cambios antes de programar.': 'Save your changes before scheduling.',
  'Listo, renovamos el permiso de tu cuenta.': "Done, we've renewed your account's permission.",
  'Listo, conectamos tu cuenta.': "Done, we've connected your account.",
  'Tus cuentas': 'Your accounts',
  Listo: 'Done',
  '+ Conectar otra': '+ Connect another',
  'Cargando…': 'Loading…',
  'Todavía no tienes ninguna cuenta conectada. Conecta al menos una para poder programar.':
    "You don't have any accounts connected yet. Connect at least one to be able to schedule.",
  'Quitar {nombre}': 'Remove {nombre}',
  '¿Quitamos esta cuenta?': 'Remove this account?',
  'Autoriza a IGOR en la ventana que se abrió y vuelve aquí.': 'Authorize IGOR in the window that opened and come back here.',
  'Ya autoricé': "I've authorized it",
  '¿Cuál de estas quieres usar?': 'Which of these do you want to use?',
  'Opción {n}': 'Option {n}',
  'Nunca te pedimos la contraseña de tu red.': 'We never ask for your social network password.',
  "No pudimos bajar la toma {n}.": "We couldn't download shot {n}.",
  "Transiciones suaves": "Smooth transitions",
  "Dinámicas para redes": "Dynamic for social media",
  "Solo cortes": "Cuts only",
  "Un poco más rápido (1,1×)": "A little faster (1.1×)",
  "Se ve al instante arriba y sale así en el MP4. No cuesta créditos.": "You see it right away above and the MP4 comes out like that. No credits.",
  "Juntando las tomas…": "Gathering the shots…",
  "Descargar las tomas (ZIP)": "Download the shots (ZIP)",
  "¿Algo no cuadra (un logo distinto, una cara que cambia, un salto brusco)? Abre ese plano abajo y dime qué corregir: IGOR lo redibuja, lo anima y vuelve a montar el video.": "Something off (a different logo, a face that changes, an abrupt jump)? Open that shot below and tell me what to fix: IGOR redraws it, animates it and re-edits the video.",
  "Se vuelve a dibujar, se anima de nuevo y se monta el video solo. La animación y el montaje se cobran aparte, como siempre.": "It gets redrawn, animated again and the video is re-edited automatically. Animation and editing are charged separately, as always.",
  "¿No sabes qué estilo o nivel elegir?": "Not sure which style or level to choose?",
  "Te ayudo con tres preguntas.": "I'll help you with three questions.",
  "¿Cómo quieres que se vea?": "How should it look?",
  "Como grabado con el celular": "Like shot on a phone",
  "Una persona real, estilo reseña": "A real person, review style",
  "Como una película": "Like a movie",
  "Personas y lugares que parecen reales": "People and places that look real",
  "Animado": "Animated",
  "3D, dibujo, anime o plastilina": "3D, drawing, anime or clay",
  "Tu producto lindo": "Your product looking great",
  "Como una sesión de fotos": "Like a photo shoot",
  "¿Alguien habla?": "Does anyone speak?",
  "Sí, habla a cámara": "Yes, to the camera",
  "Se le mueven los labios": "Their lips move",
  "Una voz que narra": "A narrator voice",
  "Voz en off sobre las escenas": "Voice-over on the scenes",
  "Nadie": "Nobody",
  "Solo música y sonidos": "Just music and sounds",
  "¿Qué te importa más?": "What matters most to you?",
  "Que se vea lo mejor posible": "That it looks as good as possible",
  "Cuesta más créditos": "Costs more credits",
  "Buen resultado, buen precio": "Good result, good price",
  "Rinde más tu saldo": "Your balance goes further",
  "Te recomiendo un Anuncio UGC con tu presentadora": "I recommend a UGC ad with your presenter",
  "Te recomiendo: {estilo} · {nivel}": "I recommend: {estilo} · {nivel}",
  "Hacerlo con mi presentadora": "Make it with my presenter",
  "Listo: ya quedó elegido abajo. Puedes cambiarlo si quieres.": "Done: it's selected below. You can change it if you want.",
  "Usar esta recomendación": "Use this recommendation",
  "Una persona que habla a cámara, como grabada con el celular: hazlo como Anuncio UGC con tu presentadora. Su cara y su voz quedan fijas en todos tus videos.": "A person talking to camera, as if filmed with a phone: make it as a UGC ad with your presenter. Their face and voice stay the same in all your videos.",
  "Uso el estilo de tus personajes elegidos para que no cambien de cara.": "I use your chosen characters' style so their faces don't change.",
  "Cine realista: personas y lugares que parecen filmados de verdad.": "Realistic cinema: people and places that look actually filmed.",
  "Foto de producto: tu producto limpio, con luz suave, como en una sesión de estudio.": "Product photo: your product clean, with soft light, like a studio shoot.",
  "3D tipo película animada: el animado que más gusta y que mejor mantiene a los personajes. Si prefieres otro trazo, elige 2D, anime o plastilina abajo.": "3D like an animated movie: the most liked animation and the one that keeps characters most consistent. If you prefer another look, choose 2D, anime or clay below.",
  "Premium: movimiento más fino y personajes más estables de un plano a otro.": "Premium: smoother motion and more consistent characters from shot to shot.",
  "Estándar: muy buena calidad al mejor precio.": "Standard: very good quality at the best price.",
  "Tu historia tiene mucha acción: en Premium se nota bastante la diferencia. Considéralo.": "Your story has a lot of action: Premium makes a noticeable difference. Consider it.",
  "Con narrador: la voz va aparte y se elige al final, sin costo extra de animación.": "With a narrator: the voice is separate and chosen at the end, with no extra animation cost.",
  "Sin voz: la música y los sonidos llevan el ritmo.": "No voice: music and sounds set the rhythm.",
  "Para foto de producto el Estándar ya se ve muy bien: te ahorras créditos.": "For product photos Standard already looks great: you save credits.",
  "Tu material": "Your media",
  "Subiendo {n} de {total}…": "Uploading {n} of {total}…",
  "{n} archivo(s) pesan más de 50 MB: expórtalos en 1080p o recórtalos y vuelve a subirlos.": "{n} file(s) are larger than 50 MB: export them in 1080p or trim them and upload again.",
  "{n} archivo(s) no son fotos (JPG, PNG, WEBP) ni videos (MP4, MOV).": "{n} file(s) are not photos (JPG, PNG, WEBP) or videos (MP4, MOV).",
  "Trayendo tus archivos…": "Bringing your files…",
  "¿Borrar «{nombre}»?": "Delete \"{nombre}\"?",
  "Editar tu video": "Edit your video",
  "‹ Volver a tu material": "‹ Back to your media",
  "Tus fotos y videos reales. Las fotos se usan en tus diseños y tus videos se editan aquí, con subtítulos y tu logo.": "Your real photos and videos. Photos are used in your designs and your videos are edited here, with subtitles and your logo.",
  "Subir fotos o videos": "Upload photos or videos",
  "Traer de Google Drive": "Bring from Google Drive",
  "Traer de Dropbox": "Bring from Dropbox",
  "Fotos JPG, PNG o WEBP y videos MP4 o MOV, hasta 50 MB cada uno.": "JPG, PNG or WEBP photos and MP4 or MOV videos, up to 50 MB each.",
  "Aún no tienes material. Sube fotos de tu producto, tu local o tu equipo, y los videos que grabas: IGOR los usa en tus piezas.": "You don't have any media yet. Upload photos of your product, your place or your team, and the videos you record: IGOR uses them in your posts.",
  "Tus videos": "Your videos",
  "Editar este video": "Edit this video",
  "Borrar": "Delete",
  "Para usarlas, en Diseño gráfico marca «Usar mis fotos reales»: IGOR elige la que mejor va con cada publicación.": "To use them, check \"Use my real photos\" in Graphic design: IGOR picks the best one for each post.",
  "¿Le ponemos subtítulos?": "Shall we add subtitles?",
  "IGOR escucha tu video y escribe lo que dices para los subtítulos (1 crédito; si no se entiende la voz, no se cobra). Después editas gratis: logo, ritmo, cortes de silencios y transiciones.": "IGOR listens to your video and writes what you say for the subtitles (1 credit; if the voice can't be understood, you're not charged). Then you edit for free: logo, pace, silence cuts and transitions.",
  "Escuchando tu video…": "Listening to your video…",
  "Sí, con subtítulos": "Yes, with subtitles",
  "Sin subtítulos": "No subtitles",
  "Cargando el editor…": "Loading the editor…",
  "Usar mis fotos reales ({n} en Tu material): IGOR elige la que mejor va con cada publicación.": "Use my real photos ({n} in Your media): IGOR picks the best one for each post.",
  "¿Tienes fotos de tu producto, tu local o tu equipo? Súbelas en «Tu material» y tus diseños las usarán.": "Do you have photos of your product, your place or your team? Upload them in \"Your media\" and your designs will use them.",
  "¿Tienes fotos de tu producto, tu local o tu equipo? Súbelas y tus diseños las usarán.": "Do you have photos of your product, your place or your team? Upload them and your designs will use them.",
  "Subir mis fotos": "Upload my photos",
  "Cada estática usa {estatica} créditos y cada carrusel, {carrusel}.": "Each static post uses {estatica} credits and each carousel, {carrusel}.",
  "{programadas} programadas · {listas} listas para programar · {faltan} por resolver": "{programadas} scheduled · {listas} ready to schedule · {faltan} to fix",
  "No queda nada por salir este mes.": "Nothing left to go out this month.",
  "Ver el calendario del mes": "See the month's calendar",
  "‹ Ver solo lo que viene": "‹ See only what is coming up",
  "Tus redes conectadas y lo que sale cada día.": "Your connected accounts and what goes out each day.",
  "personas te vieron": "people saw you",
  "publicaciones salieron": "posts went out",
  "Tu mejor publicación fue «{titulo}», con {n} interacciones.": "Your best post was \"{titulo}\", with {n} interactions.",
  "sin título": "untitled",
  "Lo que más te funcionó: {formato}.": "What worked best: {formato}.",
  "El tema que más gustó: {tema}.": "The most liked topic: {tema}.",
  "Vas mejor que antes de IGOR: {ahora} interacciones por publicación frente a {antes}.": "You're doing better than before IGOR: {ahora} interactions per post versus {antes}.",
  "Todavía por debajo de antes de IGOR: {ahora} interacciones por publicación frente a {antes}. Dale unas semanas.": "Still below before IGOR: {ahora} interactions per post versus {antes}. Give it a few weeks.",
  "Aún no hay publicaciones medidas este mes. Cuando salgan, toca «Actualizar ahora».": "No posts measured this month yet. When they go out, tap \"Update now\".",
  "Ver todo el detalle": "See all the details",
  "‹ Ver el resumen": "‹ See the summary",
  "Abrir la escena {n}": "Open scene {n}",
  "Ver y editar": "View and edit",
  "Escena {n}": "Scene {n}",
  "Escena anterior": "Previous scene",
  "Escena {n} de {total}": "Scene {n} of {total}",
  "Escena siguiente": "Next scene",
  "Todavía sin imagen": "No image yet",
  "Qué pasa": "What happens",
  "¿Solo quieres otra versión, sin cambiar nada?": "Just want another version, without changing anything?",
  "Qué pasa en esta escena": "What happens in this scene",
  "escríbelo con tus palabras: quién hace qué": "write it in your own words: who does what",
  "¿Algo más que cambiar?": "Anything else to change?",
  "Cola de edición: {n}": "Edit queue: {n}",
  "Escenas {lista}": "Scenes {lista}",
  "se corrigen solas cuando IGOR termine lo que está haciendo": "they get fixed automatically when IGOR finishes what it's doing",
  "Corregir todas · {n} créditos": "Fix all · {n} credits",
  "Vaciar la cola": "Empty the queue",
  "En la cola": "In the queue",
  "Esta escena ya está en la cola: «{cambio}»": "This scene is already in the queue: \"{cambio}\"",
  "Agregar a la cola · se corrige cuando IGOR termine": "Add to queue · fixed when IGOR finishes",
  "Agregar a la cola": "Add to queue",
} satisfies Record<string, string>;
